'use strict';

function ctrl($scope, Global, $location, timeFormat, fetchStream, socketIo, settings, $http, $window) {
    $scope.global = Global;
    this.api = api;
}

ctrl.$inject = ['$scope', 'Global', '$location', 'timeFormat', 'fetchStream', 'socketIo', 'settings', '$http', '$window'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/landing/controllers/live.ts
 **/